import { revisions as _revisions } from "../../standardAttachables.js";
import { reviseIsi } from "./actions.js";

export const isiRevisions = {
    ..._revisions,
    "headers": [_revisions.headers[0], _revisions.headers[1]],
    "actions": [{
        "label": "Revise Information Security Risk",
        "action": reviseIsi
    }],
    "rowActions": [{
        "label": "Download",
        async action({ pageItem, rowItem, db }) {
            let url = await db.download(`Database/InformationSecurityRisks/${pageItem.ID}/Revisions/${rowItem.ID}/${rowItem.File}`);
            window.open(url, "fileView", "popup");
        }
    }]
};

export default [isiRevisions];
